import {PageRootModel, SpaModel} from '../../generated/core';
import {modelToProps} from '../infrastructure/api/modelToProps';

export const getPageRootModel = (model: SpaModel) =>
    modelToProps(
        model?.model[':children']?.[model.path]?.[':items']?.['root'],
        model.path
    ) as PageRootModel;
